<template>
    <div>
        <vue-phone-number-input
            :border-radius="0"
            :default-country-code="defaultCountryCode"
            :id="name"
            @input="newInput($event)"
            :no-validator-state="true"
            @update="newUpdate($event)"
            :value="value"
        ></vue-phone-number-input>
        <input :name="phoneNumberInputName" type="hidden" :value="phoneNumberInfo.formattedNumber || ''">
        <input :name="phoneCountryCodeInputName" type="hidden" :value="phoneNumberInfo.countryCode || ''">
        <div class="help-block" style="color: #a94442" v-if="error.length">{{ error }}</div>
    </div>
</template>

<script>
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
export default {
    name: 'PhoneInput',

    components: {
        VuePhoneNumberInput,
    },

    props: {
        associatedEntityName: {
            default: '',
            required: false,
            type: String,
        },
        defaultCountryCode: {//Pass this in, if editing a phone number.
            default: 'GB',
            required: false,
            type: String,
        },
        error: {
            default: '',
            required: false,
            type: String,
        },
        name: {
            default: 'phone',
            required: false,
            type: String,
        },
        theme: {
            default: '',
            required: false,
            type: String,
        },
        value: {//This should be the phone number WITHOUT country code.
            required: true,
            type: String,
        },
    },

    data() {
        return {
            phoneNumberInfo: {},
        }
    },

    computed: {
        phoneNumberInputName() {
            return this.associatedEntityName.length
                ? `${this.associatedEntityName}[${this.name}]`
                : this.name;
        },
        phoneCountryCodeInputName() {
            return this.associatedEntityName.length
                ? `${this.associatedEntityName}[${this.name}_country_code]`
                : `${this.name}_country_code`;
        },
    },

    methods: {
        dashcoreApplyStyles(countrySelectorEl, phoneInputEl) {
            let borderColor = '#c6d3e6',
                borderRadius = '10rem';

            phoneInputEl.classList.add('phone-input-dashcore');

            Object.assign(countrySelectorEl.style, {
                borderBottomLeftRadius: borderRadius,
                borderColor,
                borderTopLeftRadius: borderRadius,
            });

            Object.assign(phoneInputEl.style, {
                borderBottomRightRadius: borderRadius,
                borderColor,
                borderTopRightRadius: borderRadius,
            });

            //The plugin resets borderColor after blur, so we have to override them again.
            countrySelectorEl.onblur = e => e.target.style.borderColor = borderColor;
            phoneInputEl.onblur = e => e.target.style.borderColor = borderColor;
        },
        newInput(phoneNumber) {
            this.$emit('input', phoneNumber);
        },
        newUpdate(phoneNumberInfo) {
            Object.assign(this, {phoneNumberInfo});
        },
    },

    mounted() {
        if (this.theme.length) {
            let countrySelectorEl = document.getElementById(`${this.name}-4_country_selector`),
                phoneInputEl = document.getElementById(`${this.name}-4_phone_number`);

            this[`${this.theme}ApplyStyles`](countrySelectorEl, phoneInputEl);
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Utility/Forms/InputFields/PhoneInput.vue